import { fromEvent, Observable } from "rxjs";
import * as CryptoJS from "crypto-js";

const obj = {};
export const urlShortener = (longURL: string) => {
  if (longURL) {
    let shortURL = "short.ly/" + longURL.replace(/[^a-z]/g, "").slice(-4);
    if (!obj[shortURL]) {
      obj[shortURL] = longURL;
    }
    return shortURL;
  }
};
export const urlRedirector = (shortURL: string) => {
  return obj[shortURL];
};

export function createCustomEventObservable<T>(
  iframe: HTMLIFrameElement,
  eventName: string,
  origin: string
): Observable<T> {
  return new Observable<T>((observer) => {
    const eventListener = (event: MessageEvent) => {
      if (event.origin === origin && event.data.eventName === eventName) {
        observer.next(event.data.payload);
      }
    };

    window.addEventListener("message", eventListener, false);

    return () => {
      window.removeEventListener("message", eventListener, false);
    };
  });
}

export const transformArr = (arr) => {
  const filteredArr = arr.filter((item) => item !== null && item !== "");

  const result = filteredArr.map((item) => {
    if (item === false) {
      return false; // Retain the false value
    } else if (typeof item === "object") {
      const transformedItem = {};
      for (let key in item) {
        if (/^[a-z][a-zA-Z0-9]*$/.test(key)) {
          transformedItem[key] = item[key];
        } else {
          const words = key.trim().split(/\s+/);
          const camelCaseKey = words
            .map((word, index) => {
              if (index === 0) {
                return word.toLowerCase();
              }
              return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join("");
          transformedItem[camelCaseKey] = item[key];
        }
      }
      return transformedItem;
    } else if (typeof item === "string") {
      const words = item.trim().split(/\s+/);
      const key = words
        .map((word, index) => {
          if (index === 0) {
            return word.toLowerCase();
          }
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join("");
      return { [key]: true };
    }
  });

  return result;
};

export const filterArr = (arr) => {
  if (arr.every((item) => typeof item === "object")) {
    return arr.filter((obj) =>
      Object.values(obj).some((value) => value === true)
    ); // Filter objects with true value
  } else if (arr.every((item) => typeof item === "string")) {
    return transformArr(arr);
  } else {
    return arr.filter((item) => typeof item === "object");
  }
};

export const SECRET_KEY = "xtwVKa3qQSlRwMU1HsZ6vbZ++O1t0jspbUgtsZ+4amU=";

export function encryptRequest(req) {
  const encryptedValue = CryptoJS.AES.encrypt(
    JSON.stringify(req),
    CryptoJS.enc.Utf8.parse("1da4f77a96e54490"),
    {
      iv: CryptoJS.enc.Utf8.parse("$9jYKuTmQ_7g&9+9"),
      mode: CryptoJS.mode.CBC,
      keySize: 128 / 8,
    }
  );

  return encryptedValue;
}

// export function decryptData(res) {
//   return JSON.parse(res.toString(CryptoJS.enc.Utf8));
// }

export function decryptResponse(value) {
  try {
    const key = CryptoJS.enc.Utf8.parse("1da4f77a96e54490");
    const iv1 = CryptoJS.enc.Utf8.parse("$9jYKuTmQ_7g&9+9");
    const plainText = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv1,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return JSON.parse(plainText.toString(CryptoJS.enc.Utf8));
  } catch (e) {}
}

export function isEmailValid(email: string) {
  return /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email);
}

export const addHyphen = (ref) => {
  return `${ref.slice(0, 3)}-${ref.slice(3, -3)}-${ref.slice(-3)}`;
};
